import clsx from "clsx";
import { ReactNode } from "react";
import { getFormattedTextSpans } from "src/utils/textFormatting";

type UserMessageProps = {
  children: string;
  opaque?: boolean;
  icon?: ReactNode;
};

export const UserMessage = ({ children, opaque, icon }: UserMessageProps) => {
  return (
    <div
      className={clsx(
        "mb-2.5 ml-2 flex min-h-[1.75rem] max-w-[66%] animate-intro-fade items-center gap-2 break-words rounded-2xl p-2 font-sans text-sm leading-tight text-gray-500 shadow-md",
        opaque ? "bg-white/75" : "bg-gray-100",
      )}>
      <div className="inline-block">
        {getFormattedTextSpans(children).map((t, key) => (
          <span
            key={key}
            className={clsx(
              t.bold && "font-bold",
              t.italic && "italic",
              t.link && "text-blue-500 underline",
              t.underline && "underline",
            )}>
            {t.text}
          </span>
        ))}
      </div>
      {icon}
    </div>
  );
};
